var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSync(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sync 1",
    clipPath: "url(#clip0_1324_22876)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 3.03754V6.24375C18 6.86507 17.4963 7.36875 16.875 7.36875H13.6688C13.0475 7.36875 12.5438 6.86507 12.5438 6.24375C12.5438 5.62243 13.0475 5.11875 13.6688 5.11875H14.5284C13.2861 3.33826 11.2502 2.25 9 2.25C6.20019 2.25 3.73191 3.93444 2.71174 6.54128C2.48527 7.11988 1.83263 7.40531 1.25409 7.17891C0.675492 6.95246 0.390023 6.29986 0.616465 5.72129C1.26893 4.05408 2.39351 2.63085 3.86863 1.60545C5.37954 0.555152 7.15391 0 9 0C10.8461 0 12.6205 0.555152 14.1314 1.60541C14.7317 2.02271 15.274 2.50597 15.75 3.04471V3.03757C15.75 2.41625 16.2537 1.91257 16.875 1.91257C17.4963 1.91257 18 2.41622 18 3.03754ZM16.7459 10.8211C16.1673 10.5947 15.5147 10.8802 15.2883 11.4588C14.2681 14.0656 11.7998 15.75 9 15.75C6.79757 15.75 4.80045 14.7075 3.55184 12.9938H4.33121C4.95253 12.9938 5.45621 12.4901 5.45621 11.8688C5.45621 11.2474 4.95253 10.7438 4.33121 10.7438H1.125C0.503684 10.7438 0 11.2474 0 11.8688V15.075C0 15.6963 0.503684 16.2 1.125 16.2C1.74632 16.2 2.25 15.6963 2.25 15.075V14.9553C2.72602 15.4941 3.2683 15.9773 3.86863 16.3946C5.37954 17.4448 7.15391 18 9 18C10.8461 18 12.6205 17.4448 14.1314 16.3946C15.6065 15.3692 16.7311 13.946 17.3835 12.2787C17.61 11.7002 17.3245 11.0476 16.7459 10.8211Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1324_22876"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSync);
export default __webpack_public_path__ + "static/media/icon_sync.3cb664574204d37f104dcc954231fd61.svg";
export { ForwardRef as ReactComponent };